export const BASE_API_URL = `${import.meta.env.VITE_APP_DJANGO_BACKEND_HOST}`;
export const WS_BASE_URL = BASE_API_URL.replace('http', 'ws');
